"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Dataset_1 = require("./Dataset");
/**
 * NFT Dataset.
 */
class NftDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftCreateRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createNft)(req);
        /**
         * Create batch NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftCreateRequest}
         * @returns
         */
        this.createBatch = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createBatchNft)(req);
        /**
         * Set NFT for sale
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftSetForSaleRequest}
         * @returns
         */
        this.setForSale = (req) => this.sendRequest(interfaces_1.WEN_FUNC.setForSaleNft)(req);
        /**
         * Withdraw NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftWithdrawRequest}
         * @returns
         */
        this.withdraw = (req) => this.sendRequest(interfaces_1.WEN_FUNC.withdrawNft)(req);
        /**
         * Deposit NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link ProjectDeactivateRequest}
         * @returns
         */
        this.deposit = (req) => this.sendRequest(interfaces_1.WEN_FUNC.depositNft)(req);
        /**
         * Update unsold NFT.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftUpdateUnsoldRequest}
         * @returns
         */
        this.updateUnsold = (req) => this.sendRequest(interfaces_1.WEN_FUNC.updateUnsoldNft)(req);
        /**
         * Buy NFT.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftPurchaseRequest}
         * @returns
         */
        this.order = (req) => this.sendRequest(interfaces_1.WEN_FUNC.orderNft)(req);
        /**
         * Bin on NFT.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftBidRequest}
         * @returns
         */
        this.openBid = (req) => this.sendRequest(interfaces_1.WEN_FUNC.openBid)(req);
        /**
         * Bulk purchase of NFTs
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftPurchaseBulkRequest}
         * @returns
         */
        this.bulkPurchase = (req) => this.sendRequest(interfaces_1.WEN_FUNC.orderNftBulk)(req);
        /**
         * Transfer NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link NftTransferRequest}
         * @returns
         */
        this.transfer = (this.sendRequest(interfaces_1.WEN_FUNC.nftTransfer));
        /**
         * Mint metadata NFT
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link MintMetadataNftRequest}
         * @returns
         */
        this.mintMetadata = (this.sendRequest(interfaces_1.WEN_FUNC.mintMetadataNft));
        /**
         * Get all NFTs by collection. Real time stream.
         *
         * @param collection
         * @param orderBy
         * @param orderByDir
         * @param startAfter
         * @returns
         */
        this.getByCollectionLive = (collection, orderBy, orderByDir, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['hidden', 'collection'],
                fieldValue: [false, collection],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy,
                orderByDir,
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Get all NFTs by owner. Real time stream.
         * @param owner
         * @param startAfter
         * @returns
         */
        this.getByOwnerLive = (owner, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['hidden', 'owner'],
                fieldValue: [false, owner],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['updatedOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.NftDataset = NftDataset;
